import { useTranslation } from "react-i18next";
import { useMemo } from "react";

import { Typography, Grid } from "@mui/material";

import { getExamSectionText } from "../../../../utils/examReportsHelper";

const MultiExamReportPanel = ({ exam }) => {
  const { t } = useTranslation();

  const allExamSections = useMemo(() => {
    const examSectionsKeys = Object.keys(exam).filter((key) =>
      key.includes("Sections")
    );
    return examSectionsKeys.filter((key) => exam[key]?.length > 0);
  }, [exam]);

  const completedExams = useMemo(
    () =>
      allExamSections
        .map((examSection) => {
          return exam[examSection].filter((e) => Boolean(e.completionDate));
        })
        .flat(),
    [allExamSections, exam]
  );

  const uncompletedExams = useMemo(
    () =>
      allExamSections
        .map((examSection) => {
          return exam[examSection].filter((e) => !Boolean(e.completionDate));
        })
        .flat(),
    [allExamSections, exam]
  );

  return (
    <Grid container sx={{ display: "flex" }} className="retinalogik-package">
      <Grid
        item
        xs={12}
        mt={4}
        p="8px"
        sx={{
          display: "flex",
          border: "1px solid black",
          flexDirection: { xs: "column", md: "row" },
          gap: "32px",
        }}
      >
        <Grid item xs={12} md={6}>
          <Typography fontWeight={600} mb="4px">
            {t("word_completed_exams")}:
          </Typography>
          {completedExams?.length > 0 ? (
            completedExams?.map((completedExam) => (
              <Typography key={completedExam.id}>
                {getExamSectionText(completedExam, t)}
              </Typography>
            ))
          ) : (
            <Typography>N/A</Typography>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography fontWeight={600} mb="4px">
            {t("word_uncompleted_exams")}:
          </Typography>
          {uncompletedExams?.length > 0 ? (
            uncompletedExams?.map((uncompletedExam) => (
              <Typography key={uncompletedExam.id}>
                {getExamSectionText(uncompletedExam, t)}
              </Typography>
            ))
          ) : (
            <Typography>N/A</Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MultiExamReportPanel;
